import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatCheckboxChange, MatDialogRef, PageEvent } from '@angular/material';
import { Search } from 'src/@core/interfaces/search';
import { AppService } from 'src/@core/services/app.service';
import { JobService } from 'src/@core/services/job/job.service';
import { NotificationService } from 'src/@core/services/notification.service';

@Component({
  selector: 'hour4u-admin-assign-members',
  templateUrl: './assign-members.component.html',
  styleUrls: ['./assign-members.component.scss']
})
export class AssignMembersComponent implements OnInit {
  pageSizeOptions: number[] = [10, 20, 50, 100, 500];
  searchParams = [];
  resultsLength: number = 0;
  pageIndex: number = 0;
  pageSize: number = 10;
  teamMembers: any[] = [];
  searchByName: any = null;
  timeoutRef: ReturnType<typeof setTimeout>;
  selectedAll: boolean = false;
  selectedTeamMembers = [];
  profile = this.appService.getCurrentAccount();
  isLoading: boolean = false;
  diameter = 40;
  loaderColor: string;
  mode = 'indeterminate';

  constructor(
    private appService: AppService,
    private jobService: JobService,
    private notify: NotificationService,
    public dialogRef: MatDialogRef<AssignMembersComponent>,
    @Inject(MAT_DIALOG_DATA) public selectedJobDetails: any,
  ) { }

  ngOnInit() {
    this.fetchTeamMembers();
  }

  // fetch roles List
  fetchTeamMembers() {
    this.searchParams = [];
    this.teamMembers = [];
    const entityId = this.profile.entity.id;
    this.isLoading = true;
    if (entityId) {
      this.searchParams = [];
      if (this.searchByName) {
        this.searchParams.push(new Search('query', this.searchByName));
      }

      // Add createdOn and desc to the payload
      const sortField = 'createdOn';
      const sortOrder = 'desc';
      this.jobService.searchAndSortTeamMembersv2(
        entityId,
        this.pageIndex,
        this.pageSize,
        sortField,
        sortOrder,
        this.searchParams
      ).subscribe(data => {
        this.teamMembers = data.content;
        this.isLoading = false;
        console.log(this.teamMembers)

        if (this.selectedAll) {
          let selection = Object.assign([], this.selectedTeamMembers);
          this.selectedTeamMembers = [];
          selection.forEach(ele => {
            this.teamMembers.forEach(el => {
              if (el.id == ele.id) {
                this.selectedTeamMembers.push(el);
              }
            })
          })
        } else {
          if (this.selectedTeamMembers && this.selectedTeamMembers.length) {
            this.selectedTeamMembers.forEach(ele => {
              this.teamMembers.forEach(el => {
                el.status = ele.status;
                if (el.id == ele.id) {
                  el.checked = true;
                }
              })
            })
          }
        }

        this.resultsLength = data.totalElements;
      }, error => {
        this.isLoading = false;
        this.notify.showMessage('Something went wrong!', 2000);
      });
    } else {
      console.warn('Entity ID is not available. Unable to fetch teamMembers.');
    }
  }

  onPageChange(event: PageEvent): void {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.fetchTeamMembers();
  }

  // Get Initial letter from JobSeeker name
  getUserNameInitial(full_name) {
    let initialOfName = null;
    if (full_name) {
      if (full_name.split(' ').length == 1) {
        initialOfName = full_name.split(' ')[0].split('')[0];
      }
      if (full_name.split(' ').length > 1) {
        initialOfName = full_name.split(' ')[0].split('')[0] + (full_name.split(' ')[1].split('')[0] ? full_name.split(' ')[1].split('')[0] : '')
      }
      return initialOfName ? initialOfName : full_name.split('')[0];
    }
  }

  // common search filter
  search() {
    clearTimeout(this.timeoutRef);
    this.timeoutRef = setTimeout(() => {
      this.fetchTeamMembers();
    }, 700);
  }

  toggle(item, event: MatCheckboxChange) {
    // this.selection = [];
    console.log(this.selectedTeamMembers)
    if (event.checked) {
      this.selectedTeamMembers.push(item);
    } else {
      const index = this.selectedTeamMembers.findIndex(x => x.id === item.id);
      if (index >= 0) {
        this.selectedTeamMembers.splice(index, 1);
      }
    }
  }

  exists(item) {
    if (this.selectedTeamMembers && this.selectedTeamMembers.length)
      return this.selectedTeamMembers.indexOf(item) > -1;
  };

  isIndeterminate() {
    if (this.selectedTeamMembers && this.selectedTeamMembers.length)
      return (this.selectedTeamMembers.length > 0 && !this.isChecked());
  };

  isChecked() {
    if (this.selectedTeamMembers && this.selectedTeamMembers.length)
      return this.selectedTeamMembers.length === this.teamMembers.length;
  };

  toggleAll(event: MatCheckboxChange) {
    this.selectedAll = event.checked;
    this.selectedTeamMembers = [];
    if (!this.selectedAll) {
      this.teamMembers.forEach(el => {
        el.checked = false;
      })
    }
    if (event.checked) {
      this.teamMembers.forEach(row => {
        if (!row.assigned)
          this.selectedTeamMembers.push(row)
      });
    } else {
      this.selectedTeamMembers.length = 0;
    }
  }

  // Disable send request btn
  disable() {
    if (this.selectedTeamMembers && this.selectedTeamMembers.length == 0) {
      return true;
    } else {
      return false;
    }
  }

  // Send request
  sendRequest() {
    this.isLoading = true;
    console.log(this.selectedTeamMembers);
    // let obj = null;
    // console.log(this.selectedJobDetails);
    // let entityIds = [];
    // this.selectedTeamMembers.forEach(ele => {
    //   entityIds.push(ele.id);
    // })
    // if (this.selectedTeamMembers.length) {
    //   obj = {
    //     "jobId": this.selectedJobDetails.id,
    //     "entityIds": entityIds,
    //   }
    //   this.employmentService.assignJobSupervisorAdmin(obj).subscribe(res => {
    //     this.isLoading = false;
    //     // if (res) {
    //     this.notify.showMessage("Selected agencies assigned successfully!", 2000)
    //     this.dialogRef.close(true);
    //     // } else {
    //     //   this.notify.showMessage('Something went wrong!', 2000);
    //     // }
    //   }, (err: any) => {
    //     this.isLoading = false;
    //     this.notify.showMessage('Something went wrong!', 2000);
    //   })
    // } else {
    //   this.isLoading = false;
    //   this.notify.showMessage('You have not selected any Agency!', 2000);
    // }
  }

  ngOnDestroy(): void {
    clearTimeout(this.timeoutRef);
  }
}
